import { render, staticRenderFns } from "./recommended-accommodation.vue?vue&type=template&id=c0c858dc&scoped=true&"
import script from "./recommended-accommodation.vue?vue&type=script&lang=js&"
export * from "./recommended-accommodation.vue?vue&type=script&lang=js&"
import style0 from "./recommended-accommodation.vue?vue&type=style&index=0&id=c0c858dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c858dc",
  null
  
)

export default component.exports